<template>
    <div class="edit">
        <shop-status-bar
            v-if="!isNaN(formData.shop_base_auditStatus)"
            :status="formData.shop_base_auditStatus"
            :reason="formData.shop_base_auditReject"
        >
            <el-button class="status-btn" type="primary" @click="submit"
                >重新提交审核</el-button
            >
        </shop-status-bar>
        <div v-for="template in montageTemplateList" :key="template._id">
            <retail-title :main-title="template.templateName"></retail-title>
            <div class="form-wrapper">
                <render-container
                    :schema="schemaObject[template._id]"
                    :formData="formData"
                    :formRulesProps="formRules"
                    :ref="`template_${template._id}`"
                ></render-container>
            </div>
        </div>
    </div>
</template>

<script>
import { v1 as uuid } from 'uuid'
import { parseJSONString } from './../../common/utils'
import editMixins from './../../common/mixins/editMixins'
import getMixins from '../../common/mixins/getMixins'
import { SHOP_AUDIT_STATUS } from './../../common/constants'
import ShopStatusBar from './../../common/shopStatusBar'
import transformTitle from './../../common/transform/transformTitle'

export default {
    name: 'edit',
    data() {
        return {
            businessParams: null
        }
    },
    created() {
        console.log('edit', '=============================')
        // generate uuid
        this.uuid = uuid()
        // get params from query
        const {
            channelNo,
            departId,
            // projectId,
            departName,
            projectName,
            projectId
        } = this.$route.query
        // save variables
        this.channelNo = channelNo
        this.departId = departId
        this.departName = departName
        this.projectName = projectName
        this.projectId = projectId
        this.businessParams = { channelNo, departId, projectId }
        // get montage model object
        this.$apiServe.computerSettleIn
            .getShopEditDetail({
                channelNo,
                departId,
                uuid: this.uuid,
                projectId
            })
            .then(res => {
                // --------添加字段联动属性-------
                // 给关联根字段添加 rule 联动属性
                let relationData = this.addRelation(res, businessParams)
                res.marketTemplateConfigInfo.templateDetailList =
                    relationData.templateDetailList
                // ---------------
                res.marketTemplateConfigInfo.templateDetailList = transformTitle(
                    res
                )
                const businessParams = { departId }
                // 获取排序的模版
                this.montageTemplateList = this.getMontageTemplateList(res)
                // 如果有保存的数据，数据需回填
                this.formData = this.getFormData(this.montageTemplateList, res)
                this.departId = res?.info?.shop_base_departId || ''
                this.projectId = res?.info?.shop_base_projectId || ''
                // 生成每个模版的schema
                this.schemaObject = this.getSchemaObject(
                    this.montageTemplateList,
                    this.formData,
                    // businessParams
                    {
                        departId: this.departId,
                        projectId: this.projectId,
                    }
                )
                this.formRules = this.getFormRules(
                    this.montageTemplateList,
                    businessParams
                )
            })
    },
    methods: {
        submit() {
            // 获取容器中的elForm getFormInstace
            const formInstanceList = this.montageTemplateList.map(({ _id }) =>
                this.getFormInstace(this.$refs[`template_${_id}`][0])
            )
            Promise.all(
                formInstanceList.map(
                    (formInstance, index) =>
                        new Promise((resolve, reject) => {
                            // 当前表单信息
                            const currentFormFieldList = this.montageTemplateList[
                                index
                            ].templateFieldParamList.map(field => ({
                                ...field,
                                configSetting: parseJSONString(
                                    field.configSetting,
                                    {}
                                )
                            }))
                            // 联动表单校验 formcreat 组件的校验结果
                            let FCValid = this.FormCreatValidate(
                                this.formData,
                                currentFormFieldList
                            )
                            formInstance.validate(valid => {
                                FCValid && valid
                                    ? resolve(currentFormFieldList)
                                    : reject(valid)
                            })
                        })
                )
            )
                .then(currentFormFieldList => {
                    const currentFormData = this.addRelationFieldValue(
                        this.formData,
                        currentFormFieldList.flat()
                    )
                    //判断是否有营业执照
                    const merchant_spec_bizLicense_ImgText =
                        currentFormData['merchant_spec_bizLicense-ImgText'] ||
                        []
                    const shop_base_license_find =
                        merchant_spec_bizLicense_ImgText &&
                        merchant_spec_bizLicense_ImgText.find(
                            item => item.key === 'shop_base_license'
                        )

                    // 只有预审驳回后的编辑才有蓝鲸校验
                    if (
                        currentFormData.shop_base_auditStatus ===
                            SHOP_AUDIT_STATUS.PRE_REJECT &&
                        shop_base_license_find
                    ) {
                        // 营业执照与公司名称校验
                        const { shop_base_companyName } = currentFormData
                        const shop_base_license = shop_base_license_find.value
                        this.$apiServe.computerSettleIn
                            .checkShopCompanyBlueWhale({
                                shop_base_companyName,
                                shop_base_license
                            })
                            .then(() => {
                                // 校验通过，继续提交
                                this.saveForm(currentFormData)
                            })
                            .catch(err => {
                                console.log(err)
                                this.$confirm(err.msg, '提示', {
                                    confirmButtonText: '继续提交',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                })
                                    .then(() => {
                                        // 继续提交
                                        this.saveForm(currentFormData)
                                    })
                                    .catch(() => {
                                        // 返回继续修改
                                        return
                                    })
                            })
                    } else {
                        this.saveForm(currentFormData)
                    }
                })
                // false
                .catch(err => {
                    console.log(err)
                })
        },
        saveForm(currentFormData) {
            this.$apiServe.computerSettleIn
                .saveShopForm({
                    data: currentFormData,
                    channelNo: this.channelNo,
                    finished: true,
                    uuid: this.uuid,
                    departId: this.departId,
                    projectId: this.projectId,
                    // 当前页面表单 字段
                    fieldList: Object.keys(currentFormData)
                })
                .then(res => {
                    console.log(res)
                    this.$router.push({
                        name: 'detailShopComputerSettleIn',
                        query: this.businessParams
                    })
                })
        }
    },
    mixins: [editMixins, getMixins],
    components: { ShopStatusBar }
}
</script>

<style lang="scss" scoped>
.form-wrapper {
    width: 460px;
    margin: 0 auto;
}
</style>
